module.exports = __webpack_public_path__ + "static/media/about-us-banner.790a261d.png";